import { ConfirmationPageBase } from "../ConfirmationPageBase";
import { useConfirmationPageData } from "../useConfirmationPageData";

export default function ConfirmationPageAR() {
  const { employee, isLoading, error } = useConfirmationPageData();

  // Mensajes específicos para Argentina
  const title = "¡Gracias!";
  const message = "Tu valoración nos sirve para mejorar.";

  return (
    <ConfirmationPageBase
      employee={employee}
      isLoading={isLoading}
      error={error}
      title={title}
      message={message}
    />
  );
}

